import BaseClient from '@/app/model/api/response/baseApiClient'

class PlantListApi extends BaseClient {
  public getPlantList (data: any) {
    const path = '/v1/plantings'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({})

    params.append('is_all_plantings', data.is_all_plantings)
    params.append('page', data.page)

    if (data.word !== '') {
      params.append('word', data.word)
    }
    if (data.year !== 0) {
      params.append('year', data.year)
    }
    if (data.season !== 0) {
      params.append('seasons[]', data.season)
    }
    if (data.order_name !== '') {
      params.append('order_name', data.order_name)
    }
    if (data.sort === false) {
      params.append('sort', 'desc')
    } else {
      params.append('sort', 'asc')
    }

    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new PlantListApi()
